import { toJS } from 'mobx';
import { conditionConstants } from '../constants/condition.constants';
import _ from 'lodash';
import { getUrlParam } from './url.utils';
export const conditionTranslator = {
  translateOperator,
};

function translateOperator(operator) {
  switch (operator) {
    case conditionConstants.operators.EQUAL:
      return '==';
    case conditionConstants.operators.NOT_EQUAL:
      return '!=';
    case conditionConstants.operators.GREATER_THAN:
      return '>';
    case conditionConstants.operators.LESS_THAN:
      return '<';
    case conditionConstants.operators.LESS_THAN_OR_EQUAL_TO:
      return '<=';
    case conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO:
      return '>=';
    case conditionConstants.operators.AND:
      return '&&';
    case conditionConstants.operators.OR:
      return '||';
    default:
      return '';
  }
}

//Available sourceelements that can with interaction resolve conditions
const navigateOld = (module, orders, activePersonNo, environment) => {
  if (orders) {
    let order = toJS(orders)[activePersonNo];
    if (module !== undefined && order !== undefined) {
      switch (module.contentModule.type) {
        case 'FIELD':
          return fieldHandlerOld(module, order);
        case 'QUESTION':
          return questionHandlerOld(module, order);
        case 'EVENT':
          return eventHandlerOld(module, order);
        case 'EVENT_GROUP':
          return eventGroupHandler(module, order);
        case 'LANGUAGE':
          return environment.lang;
        case 'MEETING':
          return meetingHandler(order);
        default:
          return null;
      }
    }
  }
  return null;
};
const navigate = (sourceKey, orders, activePersonNo, environment) => {
  if (orders) {
    let order = toJS(orders)[activePersonNo];
    if (sourceKey && order !== undefined) {
      const sourceParams = sourceKey.split('.');
      switch (sourceParams[0].toUpperCase()) {
        case 'PERSON':
        case 'COMPANY':
          return fieldHandler(sourceParams[0], sourceParams[1], order);
        case 'QUESTIONOPTION':
          return questionOptionHandler(sourceParams[1], order);
        case 'QUESTIONTEXT':
          return questionTextHandler(sourceParams[1], order);
        case 'EVENT':
          return eventHandler(sourceParams[1], order);
        case 'LANGUAGE':
          return environment.lang;
        case 'MEETING':
          return meetingHandler(order);
        default:
          return null;
      }
    }
  }
  return null;
};

const fieldHandler = (type, name, order) => {
  return order?.[_.camelCase(type)]?.[_.camelCase(name)] ?? '';
};
const fieldHandlerOld = (module, order) => {
  let type = order[_.camelCase(module.contentModule.settings.type)];
  if (type) {
    let val = type[_.camelCase(module.contentModule.settings.fieldType)];
    if (val) {
      return val;
    }
  }
  return null;
};

const meetingHandler = (order) => {
  const meeting = order?.orderExtra?.find(orderExtra => orderExtra.name == 'Matchmaking');
  if (!meeting) return null;
  const meetingValue = meeting?.value === 'True';
  return meetingValue;
};
const questionOptionHandler = (questionId, order) => {
  let checkedOptions = order?.answer?.find(a => a.questionId == questionId)?.answerRow;
  if (!checkedOptions) return null;
  return checkedOptions.map(co => {
    return co.questionOptionId;
  });
};
const questionTextHandler = (questionId, order) => {
  let answer = order.answer?.find(a => a.questionId == questionId);
  if (answer && answer.answerRow && answer.answerRow.length > 0) {
    let row = answer.answerRow[0];
    if (row && !row.deleted) {
      return row.text;
    }
  }
  return '';
};
const questionHandlerOld = (module, order) => {
  if (module.contentModule.settings.type === 'text') {
    if (order.answer) {
      let answer = order.answer.find(a => a.questionId == module.contentModule.settings.questionId);
      if (answer && answer.answerRow && answer.answerRow.length > 0) {
        let row = answer.answerRow?.[0];
        if (row && !row.deleted) {
          return row.text;
        }
      }
    }
  }
  if (module.contentModule.settings.type === 'option') {
    let checkedOptions = order?.answer?.find(a => a.questionId == module.contentModule.settings.questionId)?.answerRow;
    if (!checkedOptions) return null;

    return checkedOptions.map(co => {
      return co.questionOptionId;
    });
  }
  return null;
};
const eventHandler = (eventId, order) => {
  if (order.orderRow) {
    let row = order.orderRow.find(or => or.eventId === parseInt(eventId));
    if (row && !row.deleted && row.status !== 'Cancelled' && row.status !== 'Rejected') {

      return true;
    }
  }
  return false;
};
const eventHandlerOld = (module, order) => {
  if (order.orderRow) {
    let row = order.orderRow.find(or => or.eventId == module.contentModule.settings.eventId);
    if (row && !row.deleted) {
      return true;
    }
  }
  return false;
};

const eventGroupHandler = (module, order) => {
  const moduleEventIds = module?.contentModule?.settings?.eventIds?.map(e => e.eventId) ?? [];
  if (order.orderRow) {
    return order.orderRow
      .filter(or => !or.deleted && or.eventId !== order.eventId && moduleEventIds.includes(or.eventId))
      .map(or => {
        return or.eventId;
      });
  }
  return [];
};

export const conditionNavigator = {
  navigateOld,
  navigate,
};
